module.exports = __webpack_public_path__ + "static/garda_full-89818e15df6bcd7028858d98c1097e71.png";